<template>
  <div class="routine-finder-resultByEmail-container">
    <div ref="primaryEmailCta" class="routine-finder-resultByEmail" :class="{ 'hideCta': isOpened, 'showCta': isClosed }">

      <button @click="openemailformpopup()" class="routine-finder-resultByEmail__button">
        <img v-if="datas && datas.image" :src="datas.image.image_url" :alt="datas.image.image_alt" />
        <span v-truncate-rich-text="{ limit: 50, ellipse: false, singleLine: true }"></span>{{ datas.email_title }}
      </button>
    </div>
    <div class="routine-finder-resultByEmail routine-finder-resultByEmail--bottomSticky"
      :class="{ 'show-sticky': showBottomStickyCta && isClosed, 'hide-sticky': !showBottomStickyCta || isOpened }">
      <button @click="openemailformpopup()" class="routine-finder-resultByEmail__button" type="button">
        <img v-if="datas && datas.image" :src="datas.image.image_url" :alt="datas.image.image_alt" />
        <span v-truncate-rich-text="{ limit: 50, ellipse: false, singleLine: true }"></span>{{ datas.email_title }}
      </button>
    </div>


    <div class="emailForm-overlay"
      :class="{ 'open': isOpened, 'close': isClosed, 'desktopScreen': !smallScreen, 'smallScreen': smallScreen }">
    </div>
    <div
      :class="{ 'open': isOpened, 'close': isClosed, 'desktopScreen': !smallScreen, 'smallScreen': smallScreen, 'msgSentSucess': successMsg_container }"
      class="routine-finder-result__emailForm__contianer">
      <div class="routine-finder-result__emailForm__close" @click="close_emailformpopup()">

        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M8.15191 8.99995L0.576172 16.5757L1.4247 17.4242L9.00044 9.84848L16.5762 17.4242L17.4247 16.5757L9.84897 8.99995L17.4247 1.42421L16.5762 0.575684L9.00044 8.15142L1.4247 0.575684L0.576172 1.42421L8.15191 8.99995Z"
            fill="black" />
        </svg>


      </div>
      <div v-if="form_container" class="routine-finder-result__emailForm__innerWrapper"
        :class="{ 'routine-finder-result__emailForm__innerWrapper--twoStep': useTwoStepEmail }">

        <!-- Single-step (unchanged behaviour when two-step flag is off) -->
        <template v-if="!useTwoStepEmail">         
           <!-- NOSONAR --> <h3 class="heading-h3" v-truncate-rich-text="{ limit: 55, ellipse: false, singleLine: false }"
            v-html="datas.title"></h3>
          <form @submit.prevent="handleSubmit">
            <div class="form-group inputbox-wrapper">
              <label for="emailId"
                v-truncate-rich-text="{ limit: 40, ellipse: false, singleLine: false }">{{ datas.email_label }}</label>
              <input type="email" id="emailId" v-model="getEmailId" @blur="checkEmailValidity"
                :placeholder="datas.sample_email" :class="{ 'emailInvalid': emailError }" />
              <div v-if="emailError" class="emailError">
                {{ datas.valid_email_label }}
              </div>
            </div>

            <div class="form-group checkbox-wrapper">
              <label for="checkbox">
                <input id="checkbox" type="checkbox" v-model="acceptedTerms" />
                <span class="customCheckbox"></span>                
                 <!-- NOSONAR --><span v-truncate-rich-text="{ limit: 450, ellipse: false, singleLine: false }"
                  class="customCheckboxText" v-html="datas.email_accent"></span>
              </label>
            </div>

            <button class="submitEmail cta cta--light" type="submit" :disabled="!isFormValid">{{ datas.cta_text }}</button>
          </form>
        </template>

        <!-- Two-step: activated only when API JSON includes enable_two_step_email_form: true -->
        <template v-else>
          <div v-if="currentStep === 1" class="routine-finder-email-two-step routine-finder-email-two-step--step1">
          <!-- NOSONAR --><h3 v-if="datas.newsletter_fields.title" class="heading-h3" v-truncate-rich-text="{ limit: 55, ellipse: false, singleLine: false }"
              v-html="datas.newsletter_fields.title"></h3>            
            <!-- NOSONAR --><div v-if="datas.newsletter_fields.text" class="routine-finder-email-two-step__intro" v-html="datas.newsletter_fields.text"></div>

            <div v-if="datas.newsletter_fields.gender_selection_title" class="form-group routine-finder-email-two-step__gender">
              <p class="routine-finder-email-two-step__gender-title">{{ datas.newsletter_fields.gender_selection_title }}</p>
              <div class="routine-finder-email-two-step__radio-row">
                <label v-for="(opt, idx) in genderOptions" :key="'g-' + idx" class="routine-finder-email-two-step__radio">
                  <input
                    v-model="selectedGender"
                    type="radio"
                    name="routineFinderGender"
                    :value="opt.id"
                    :disabled="opt.isDisabled"
                  />
                  <span>{{ opt.label }}</span>
                </label>
              </div>
            </div>

            <div v-if="datas.newsletter_fields.first_name_label" class="form-group routine-finder-email-two-step__field routine-finder-email-two-step__field--underlineOnly">
              <input id="routine-finder-email-first" v-model="firstName" type="text" autocomplete="given-name"
                :placeholder="datas.newsletter_fields.first_name_label"
                :aria-label="datas.newsletter_fields.first_name_label || null" />
            </div>
            <div v-if="datas.newsletter_fields.last_name_label" class="form-group routine-finder-email-two-step__field routine-finder-email-two-step__field--underlineOnly">
              <input id="routine-finder-email-last" v-model="lastName" type="text" autocomplete="family-name"
                :placeholder="datas.newsletter_fields.last_name_label"
                :aria-label="datas.newsletter_fields.last_name_label || null" />
            </div>

            <div class="routine-finder-email-two-step__footer">
              <div class="routine-finder-email-two-step__stepbars" role="tablist" aria-label="Form steps">
                <button type="button" class="routine-finder-email-two-step__stepbar is-active" aria-current="step"
                  @click="setStep(1)"></button>
                <button type="button" class="routine-finder-email-two-step__stepbar" @click="setStep(2)"></button>
              </div>
              <button type="button" class="submitEmail cta cta--light routine-finder-email-two-step__cta"
                @click="goToStepTwo">
                {{ datas.newsletter_fields.continue_cta_text }}
              </button>
            </div>
          </div>

          <div v-else class="routine-finder-email-two-step routine-finder-email-two-step--step2">            
            <!-- NOSONAR --><h3 v-if="datas.title" class="heading-h3" v-truncate-rich-text="{ limit: 55, ellipse: false, singleLine: false }"
              v-html="datas.title"></h3>             
            <!-- NOSONAR --><div v-if="datas.text" class="routine-finder-email-two-step__intro" v-html="datas.text"></div>

            <form @submit.prevent="onTwoStepRegisterClick">
              <div class="form-group inputbox-wrapper routine-finder-email-two-step__email">                
                <input id="emailIdTwoStep" v-model="getEmailId" type="email" autocomplete="email"
                  :placeholder="datas.email_label" :class="{ 'emailInvalid': emailError }"
                  @blur="checkTwoStepEmailValidity" />
                <div v-if="emailError && twoStepEmailErrorLabel" class="emailError">
                  {{ twoStepEmailErrorLabel }}
                </div>
              </div>

              <div class="form-group checkbox-wrapper">
                <label for="checkboxTwoStep">
                  <input id="checkboxTwoStep" v-model="acceptedTerms" type="checkbox" />
                  <span class="customCheckbox"></span>
                  <!-- NOSONAR --><span v-truncate-rich-text="{ limit: 450, ellipse: false, singleLine: false }"
                    class="customCheckboxText" v-html="datas.email_accent"></span>
                </label>
              </div>

              <div class="routine-finder-email-two-step__footer">
                <div class="routine-finder-email-two-step__stepbars" role="tablist" aria-label="Form steps">
                  <button type="button" class="routine-finder-email-two-step__stepbar" @click="setStep(1)"></button>
                  <button type="button" class="routine-finder-email-two-step__stepbar is-active" aria-current="step"
                    @click="setStep(2)"></button>
                </div>
                <button type="submit"
                  class="submitEmail cta cta--light routine-finder-email-two-step__cta routine-finder-email-two-step__register"
                  :disabled="!isStepTwoReady">
                  {{ datas.cta_text }}
                </button>
              </div>
            </form>
          </div>
        </template>
      </div>
      <div v-if="successMsg_container" class="routine-finder-result__emailForm__innerWrapper successMsg">
                  <div v-if="this.loadingIcon" class="loader-container">
                    <div class="loadMore-trigger"></div>
                    <transition name="fade">
                      <div class="loader-css">Loading</div>
                    </transition>
                  </div>
                  <div v-if="this.showSuccessMsg">
                    <!-- NOSONAR --><div class="successMsg-title" v-truncate-rich-text="{ limit: 35, ellipse: false, singleLine: false }"
                    v-html="datas.sucess_title"></div>
                    <!-- NOSONAR --><div class="successMsg-desc" v-truncate-rich-text="{ limit: 85, ellipse: false, singleLine: false }"
                    v-html="datas.success_message"></div>
                  </div>
      </div>

    </div>
  </div>
</template>
<script>
import { truncateRichText } from '@Foundation/directives/truncateRichText/truncateRichText';
import { AnalyticsHandler } from '@Foundation/analyticsHandler';

export default {
  name: 'routine-finder-result-by-email-form',
  directives: {
    truncateRichText
  },
  props: {
    datas: {
      type: {Object,String},
      required: true,
    },
    emailProductEan: {
      type: String,
      required: true,
    }
  },
  data() {
    return {
      getEmailId: '',
      emailError: false,
      acceptedTerms: false,
      smallScreen: window.matchMedia('(max-width: 650px)').matches,
      animationEnabled: false,
      initEmailpopup: false,
      isOpened: false,
      isClosed: true,
      successMsg_container: false,
      form_container: true,
      loadingIcon:true,
      showSuccessMsg: false,
      currentStep: 1,
      selectedGender: '',
      firstName: '',
      lastName: '',
      emailSubmitAttempted: false,
      isAtTop: true,
      isAtBottom: false,
      hasReachedProfileSection: false,
      scrollContainer: null,
      /** Min scroll offset before showing bottom duplicate CTA (pixels); equals measured primary `.routine-finder-resultByEmail` height. */
      primaryEmailCtaScrollThresholdPx: 0,
    }
  },
  watch: {
    isClosed() {
      this.$nextTick(() => this.measurePrimaryEmailCtaHeight());
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.bindScrollListener();
      this.setupPrimaryEmailCtaObservers();
      this.measurePrimaryEmailCtaHeight();
    });
    window.addEventListener('resize', this.measurePrimaryEmailCtaHeight);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.measurePrimaryEmailCtaHeight);
    this.teardownPrimaryEmailCtaObservers();
    this.unbindScrollListener();
  },

  computed: {
    d() {
      return typeof this.datas === 'object' && this.datas !== null ? this.datas : {};
    },
    /** Two-step nested config: `newsletter_fields` / `registration_steps` / legacy `steps`. */
    steps() {
      const s = this.d.newsletter_fields || this.d.steps;
      return s && typeof s === 'object' ? s : {};
    },
    step1() {
      const s = this.steps;
      const inner = s.step_1 || s.step1 || s;
      return {
        title: inner.title ?? this.d.step_one_title,
        text: inner.text ?? this.d.step_one_text,
        gender_selection_title: inner.gender_selection_title ?? this.d.gender_selection_title,
        first_name_label: inner.first_name_label ?? this.d.first_name_label,
        last_name_label: inner.last_name_label ?? this.d.last_name_label,
        continue_cta_text: inner.continue_cta_text ?? this.d.continue_cta_text,
        gender_options: inner.gender_options,
        gender_option_1: inner.gender_option_1 ?? this.d.gender_option_1,
        gender_option_2: inner.gender_option_2 ?? this.d.gender_option_2,
        gender_option_3: inner.gender_option_3 ?? this.d.gender_option_3,
      };
    },
    step2() {
      const s = this.steps;
      const inner = s.step_2 || s.step2 || {};
      return {
        title: inner.title ?? this.d.step_two_title,
        text: inner.text ?? this.d.step_two_text ?? this.d.text,
        register_cta_text: inner.register_cta_text ?? this.d.register_cta_text,
      };
    },
    useTwoStepEmail() {
      const v = this.d.enable_two_step_email_form;
      return v === true || v === 'true' || v === 1 || v === '1';
    },
    genderOptions() {
      const s1 = this.step1;
      if (Array.isArray(s1.gender_options) && s1.gender_options.length) {
        const normalized = s1.gender_options
          .map((item) => {
            if (typeof item === 'string') {
              const label = item.trim();
              return label ? { id: label, label, isDisabled: false } : null;
            }
            if (item && typeof item === 'object') {
              const labelValue = String(item.label || item.text || item.name || '').trim();
              if (!labelValue) {
                return null;
              }
              return {
                id: String(item.id || item.value || labelValue),
                label: labelValue,
                isDisabled: Boolean(item.isDisabled),
              };
            }
            return null;
          })
          .filter(Boolean);
        if (normalized.length) {
          return normalized;
        }
      }
      const raw = [s1.gender_option_1, s1.gender_option_2, s1.gender_option_3];
      const opts = raw
        .filter((x) => typeof x === 'string' && x.trim().length > 0)
        .map((label) => ({ id: label, label, isDisabled: false }));
      return opts;
    },
    /**
     * Same pattern as single-step `datas.valid_email_label`; all copy from API JSON (no hardcoded default).
     * Order: email_service_data.valid_email_label → email_validation_error_message
     */
    twoStepEmailErrorLabel() {
      return (
        this.d.valid_email_label ||
        this.d.email_validation_error_message ||
        ''
      );
    },
    isEmailValid() {
      const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
      return emailPattern.test(this.getEmailId);
    },
    isFormValid() {
      return this.isEmailValid && this.acceptedTerms;
    },
    isEmailValidTwoStep() {
      const e = (this.getEmailId || '').trim();
      if (!e || e.length >= 35) {
        return false;
      }
      const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
      return emailPattern.test(e);
    },
    isStepTwoReady() {
      return this.isEmailValidTwoStep && this.acceptedTerms;
    },
    selectedGenderOption() {
      return this.genderOptions.find((item) => item.id === this.selectedGender) || null;
    },
    showBottomStickyCta() {
      return this.useTwoStepEmail
        && this.isClosed
        && !this.successMsg_container
        && !this.isAtTop
        && !this.isAtBottom
        && !this.hasReachedProfileSection;
    },
  },
  methods: {
    bindScrollListener() {
      const modalScrollContainer = this.$el.closest('.routine_finder__modal__innerWrapper');
      this.scrollContainer = modalScrollContainer || window;
      this.scrollContainer.addEventListener('scroll', this.handleScroll, { passive: true });
      this.measurePrimaryEmailCtaHeight();
      this.updateScrollPositionState();
    },
    unbindScrollListener() {
      if (this.scrollContainer && this.scrollContainer.removeEventListener) {
        this.scrollContainer.removeEventListener('scroll', this.handleScroll);
      }
      this.scrollContainer = null;
    },
    handleScroll() {
      this.updateScrollPositionState();
    },
    updateScrollPositionState() {
      if (!this.scrollContainer) {
        return;
      }
      this.hasReachedProfileSection = this.isProfileSectionReached();
      const thresholdPx = this.primaryEmailCtaScrollThresholdPx;
      /** Until we have a positive measured height, treat as “still at top” so the duplicate CTA stays hidden. */
      const minScrollToShowSticky = thresholdPx > 0 ? thresholdPx : Infinity;
      if (this.scrollContainer === window) {
        const doc = document.documentElement;
        const top = window.pageYOffset || doc.scrollTop || 0;
        this.isAtTop = top < minScrollToShowSticky;
        this.isAtBottom = top + window.innerHeight > doc.scrollHeight - 10;
        return;
      }
      const top = this.scrollContainer.scrollTop || 0;
      this.isAtTop = top < minScrollToShowSticky;
      this.isAtBottom = top + this.scrollContainer.clientHeight > this.scrollContainer.scrollHeight - 10;
    },
    measurePrimaryEmailCtaHeight() {
      const el = this.$refs.primaryEmailCta;
      if (!el || typeof el.getBoundingClientRect !== 'function') {
        this.primaryEmailCtaScrollThresholdPx = 0;
        this.updateScrollPositionState();
        return;
      }
      const h = el.offsetHeight || el.getBoundingClientRect().height || 0;
      this.primaryEmailCtaScrollThresholdPx = Math.ceil(h);
      this.updateScrollPositionState();
    },
    setupPrimaryEmailCtaObservers() {
      if (typeof ResizeObserver === 'undefined') {
        return;
      }
      const el = this.$refs.primaryEmailCta;
      if (!el) {
        return;
      }
      this.teardownPrimaryEmailCtaObservers();
      this._primaryCtaResizeObserver = new ResizeObserver(() => this.measurePrimaryEmailCtaHeight());
      this._primaryCtaResizeObserver.observe(el);
    },
    teardownPrimaryEmailCtaObservers() {
      if (this._primaryCtaResizeObserver) {
        this._primaryCtaResizeObserver.disconnect();
        this._primaryCtaResizeObserver = null;
      }
    },
    isProfileSectionReached() {
      const parent = this.$el && this.$el.parentElement ? this.$el.parentElement : null;
      const profileElement = parent && parent.querySelector('.routine-finder-your-profile');
      if (!profileElement) {
        return false;
      }
      if (this.scrollContainer === window) {
        const profileAbsoluteTop = profileElement.getBoundingClientRect().top + window.pageYOffset;
        return window.pageYOffset + 20 >= profileAbsoluteTop;
      }
      const containerRect = this.scrollContainer.getBoundingClientRect();
      const profileRect = profileElement.getBoundingClientRect();
      const profileTopInContainer = profileRect.top - containerRect.top + this.scrollContainer.scrollTop;
      return this.scrollContainer.scrollTop + 20 >= profileTopInContainer;
    },
    setStep(n) {
      this.currentStep = n;
      if (n === 1) {
        this.emailError = false;
        this.emailSubmitAttempted = false;
      }
    },
    goToStepTwo() {
      this.currentStep = 2;
    },
    /**
     * Two-step email: same UX as `checkEmailValidity` (blur shows error state + `.emailError` message),
     * with two-step rules (non-empty, &lt; 35 chars, pattern) via `isEmailValidTwoStep`.
     */
    checkTwoStepEmailValidity() {
      if (!this.useTwoStepEmail || this.currentStep !== 2) {
        return;
      }
      this.emailError = !this.isEmailValidTwoStep;
    },
    onTwoStepRegisterClick() {
      if (!this.isStepTwoReady) {
        return;
      }
      this.emailError = false;
      this.emailSubmitAttempted = false;
      this.handleSubmit();
    },
    async sendEmail() {
      this.gaTagging();
      const apiURL = '/api/routinefinder/RoutineFinderApiBus';
      const registrationData = this.useTwoStepEmail
        ? {
            selected_gender_id: this.selectedGender || '',
            selected_gender_label: this.selectedGenderOption ? this.selectedGenderOption.label : '',
            first_name: this.firstName || '',
            last_name: this.lastName || '',
            accepted_terms: Boolean(this.acceptedTerms),
            form_steps: this.useTwoStepEmail
          }
        : {}; 
      
      const jsonData = {
        "Stage": 5,
        "Parameters": {
          "mailID": btoa(this.getEmailId),
          "origin": window.location.origin,
          "EAN": this.emailProductEan,
          ...registrationData
        }
      };
      try {
        const response = await fetch(apiURL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json;charset=utf-8' },
          body: JSON.stringify(jsonData),
        });
        if (response.ok) {
          const data = await response.json(); // Convert response to JSON  
          this.apiData = data;
          if(this.apiData?.success === true){
            this.loadingIcon = false;
            this.showSuccessMsg = true;
          } 
        }
      } catch (error) {
        console.error('Error sending email:', error);
      }
    },
    openemailformpopup() {
      this.initEmailpopup = true;
      if (this.smallScreen) {
        this.isOpened = !this.isOpened;
        this.isClosed = !this.isClosed;
      }
      else {
        this.isOpened = true;
        this.isClosed = false;
      }
    },
    handleSubmit() {
      this.sendEmail();
      this.form_container = false;
      this.successMsg_container = true;
    },
    close_emailformpopup() {
      this.isOpened = false;
      this.isClosed = true;
      this.form_container = true;
      this.successMsg_container = false;
      this.getEmailId = '';
      this.acceptedTerms = false;
      this.emailError = false;
      this.currentStep = 1;
      this.selectedGender = '';
      this.firstName = '';
      this.lastName = '';
      this.emailSubmitAttempted = false;
      this.loadingIcon = true;
      this.showSuccessMsg = false;
    },
    checkEmailValidity() {
      const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
      this.emailError = !emailPattern.test(this.getEmailId);
    },
    gaTagging(){
      AnalyticsHandler.pushDataLayer(this.datas.email_results_tagging);
    }

  }
};
</script>

<style lang="scss" src="./routine-finder-result-by-email-form.scss"></style>
